import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLockedUsers, unlockUser, updateUnlockUserStatus } from "../../../actions/users";
import ConfirmDialog from "../../commons/dialog/confirmDialog";
import useDialog from "../../commons/hooks/useDialog";
import UsersTable from "../../commons/table/usersTable";

const BlockedUsersContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const lockedUsers = useSelector((state) => state.users.lockedUsers);
  const loadingUnlock = useSelector((state) => state.users.unlockUser.isFetching);

  const unlockDialog = useDialog(null);

  useEffect(() => {
    dispatch(getLockedUsers());
  }, [dispatch]);

  const handleConfirmUnlock = () => {
    if (unlockDialog.data) {
      dispatch(unlockUser(unlockDialog.data.id)).then(() => {
        dispatch(updateUnlockUserStatus(unlockDialog.data.id));
        enqueueSnackbar(<p>Usuario desbloqueado correctamente</p>, {
          variant: "success",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        });
        unlockDialog.close();
      });
    }
  };

  return (
    <div>
      <UsersTable
        data={lockedUsers.list}
        loading={lockedUsers.isFetching}
        title="Usuarios Bloqueados"
        fetchData={() => dispatch(getLockedUsers())}
        handleUnlockUser={(user) => unlockDialog.open(user)}
        noRefresh={false}
      />

      <ConfirmDialog
        open={unlockDialog.isOpen}
        handleClose={unlockDialog.close}
        handleConfirm={handleConfirmUnlock}
        title="Desbloquear Usuario"
        text={`¿Está seguro de que desea desbloquear al usuario ${unlockDialog.data?.email}?`}
        loading={loadingUnlock}
      />
    </div>
  );
};

export default BlockedUsersContainer;
